export default __webpack_public_path__ + "da130043fe0043f3d4dc9e94ce46cfce.svg";